/**
* Image Group Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Image Group Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'image-group-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      // $( '.image-group-banner' ).each( function( key, val ) {
      //   const height = $( this ).outerHeight();

      //   const tl = gsap.timeline( {
      //     scrollTrigger: {
      //       trigger: this,
      //       start: 'top 10%',
      //       end: '80% top',
      //       scrub: 0,
      //       // markers: true,
      //       toggleClass: 'is-loaded',
      //     },
      //   } );

      //   $( this ).find( '.ball' ).each( function( ballKey, ballVal ) {
      //     const y = Math.floor( ( Math.random() * 1200 ) - 800 );
      //     const x = Math.floor( ( Math.random() * 600 ) - 310 );
      //     tl.to( ballVal, {y: y + '%', x: x + '%', ease: 'linear'}, 0 );
      //   } );
      // } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'image-group-banner', COMPONENT );
} )( app );
